"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _jsCookie = _interopRequireDefault(require("js-cookie"));
var _static = require("../static");
var _throttle = _interopRequireDefault(require("@/utils/throttle"));
var _transformState = _interopRequireDefault(require("@/utils/transformState.js"));
var dangaoActApi = _interopRequireWildcard(require("@/api/dangaoActApi"));
var orderListApi = _interopRequireWildcard(require("@/api/orderListApi.js"));
var customerOrderApi = _interopRequireWildcard(require("@/api/customerOrderApi.js"));
var _constants = require("@/utils/constants");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t5 in e) "default" !== _t5 && {}.hasOwnProperty.call(e, _t5) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t5)) && (i.get || i.set) ? o(f, _t5, i) : f[_t5] = e[_t5]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      offsetStateOption: _static.offsetStateOption,
      constants: this.$constants,
      companyappAutoList: [],
      companyappAutoListA: [],
      companyappAutoListB: [],
      dataRenage: [],
      listPram: {
        page: 1,
        limit: this.$constants.page.limit[0],
        type: 2
      },
      listData: {
        list: [],
        total: 0
      },
      listLoading: true,
      storeType: false,
      formStoreSelect: [],
      formStoreSelectedOne: [],
      orderListWx: [],
      dialogVisibleDetals: false,
      popupDetales: {},
      userTypeDic: {},
      isExporting: false,
      // 导出中状态
      isInQueue: false,
      // 是否在排队中
      currentQueuePosition: 0,
      // 当前排队位置
      queueDetail: null,
      // 排队详情信息
      exportProgress: 0 // 导出进度
    };
  },
  computed: {
    // 用于图片预览的列表
    previewImageList: function previewImageList() {
      return this.popupDetales.attachmentList || [];
    }
  },
  created: function created() {
    if (this.$getHomeType()) {
      this.userTypeDic = this.$getHomeType();
    }
  },
  mounted: function mounted() {
    if (JSON.parse(_jsCookie.default.get('JavaInfo')).supplierId === null) {
      this.handleStoreListSelect();
    } else {
      this.listPram.offlineSupplierId = JSON.parse(_jsCookie.default.get('JavaInfo')).supplierId;
      this.handleSelectedList();
    }
    this.handleAppWxOrderList();
    this.handleApiOffsetList(this.listPram);
  },
  methods: {
    throttle: _throttle.default,
    transformState: _transformState.default,
    // 核销订单列表
    handleApiOffsetList: function () {
      var _handleApiOffsetList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(listPram) {
        var _this$dataRenage, _this$dataRenage2;
        var parmres, res;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              if ((_this$dataRenage = this.dataRenage) !== null && _this$dataRenage !== void 0 && _this$dataRenage.length) {
                parmres = _objectSpread(_objectSpread({}, listPram), {}, {
                  startTime: this.dataRenage[0],
                  endTime: this.dataRenage[1]
                });
              }
              listPram = (_this$dataRenage2 = this.dataRenage) !== null && _this$dataRenage2 !== void 0 && _this$dataRenage2.length ? parmres : listPram;
              _context.n = 1;
              return orderListApi.orderApiOffsetList(listPram);
            case 1:
              res = _context.v;
              // 处理返回的数据，为图片添加腾讯云存储前缀
              if (res.list && res.list.length > 0) {
                res.list.forEach(function (item) {
                  if (item.attachmentList && item.attachmentList.length > 0) {
                    item.attachmentList = item.attachmentList.map(function (img) {
                      if (!img || img.startsWith('http')) return img;
                      return "https://hhzb-cos-1317915528.cos.ap-chengdu.myqcloud.com/".concat(img);
                    });
                  }
                });
              }
              this.listData.list = res.list;
              this.listData.total = res.total;
              this.listLoading = false;
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function handleApiOffsetList(_x) {
        return _handleApiOffsetList.apply(this, arguments);
      }
      return handleApiOffsetList;
    }(),
    // 获取到商家列表 当缓存里没有时调
    handleStoreListSelect: function () {
      var _handleStoreListSelect = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var res;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return customerOrderApi.companyAutoListByTypetApi({
                type: 4
              });
            case 1:
              res = _context2.v;
              this.storeType = true;
              this.formStoreSelect = res;
            case 2:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function handleStoreListSelect() {
        return _handleStoreListSelect.apply(this, arguments);
      }
      return handleStoreListSelect;
    }(),
    //获取到店铺列表
    handleSelectedList: function () {
      var _handleSelectedList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var res;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return customerOrderApi.companyAutoListByTypestApi({
                offlineSupplierId: this.listPram.offlineSupplierId
              });
            case 1:
              res = _context3.v;
              this.formStoreSelectedOne = res;
              this.handerSearch();
            case 2:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function handleSelectedList() {
        return _handleSelectedList.apply(this, arguments);
      }
      return handleSelectedList;
    }(),
    // 获取小程序的列表
    handleAppWxOrderList: function () {
      var _handleAppWxOrderList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var res;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _context4.n = 1;
              return customerOrderApi.companyappAutoListApi();
            case 1:
              res = _context4.v;
              this.orderListWx = res;
            case 2:
              return _context4.a(2);
          }
        }, _callee4, this);
      }));
      function handleAppWxOrderList() {
        return _handleAppWxOrderList.apply(this, arguments);
      }
      return handleAppWxOrderList;
    }(),
    // 搜索
    handerSearch: function handerSearch() {
      this.listPram.page = 1;
      this.handleApiOffsetList(this.listPram);
    },
    handleSizeChange: function handleSizeChange(val) {
      this.listPram.limit = val;
      this.handleApiOffsetList(this.listPram);
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.listPram.page = val;
      this.handleApiOffsetList(this.listPram);
    },
    // 查看订单详情
    openOrderDetail: function openOrderDetail(row) {
      console.log(row);
      this.dialogVisibleDetals = true;
      // 克隆数据以便处理图片URL
      var rowClone = JSON.parse(JSON.stringify(row));
      // 处理图片URL添加腾讯云存储前缀
      if (rowClone.attachmentList && rowClone.attachmentList.length > 0) {
        rowClone.attachmentList = rowClone.attachmentList.map(function (img) {
          if (!img || img.startsWith('http')) return img;
          return "https://hhzb-cos-1317915528.cos.ap-chengdu.myqcloud.com/".concat(img);
        });
      }
      this.popupDetales = rowClone;
    },
    // 导出
    exportList: function exportList() {
      var _this$dataRenage3,
        _this = this;
      // 构造导出参数
      var exportParams = _objectSpread({}, this.listPram);
      // 删除分页参数
      delete exportParams.page;
      delete exportParams.limit;
      if ((_this$dataRenage3 = this.dataRenage) !== null && _this$dataRenage3 !== void 0 && _this$dataRenage3.length) {
        exportParams.startTime = this.dataRenage[0];
        exportParams.endTime = this.dataRenage[1];
      }
      this.isExporting = true;
      this.exportProgress = 0;
      this.isInQueue = false;
      this.currentQueuePosition = 0;
      orderListApi.exportOfflineOrder(exportParams).then(/*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(res) {
          return _regenerator().w(function (_context5) {
            while (1) switch (_context5.n) {
              case 0:
                if (res.taskId) {
                  if (res.inQueue) {
                    _this.isInQueue = true;
                    // 获取排队详情
                    _this.fetchQueueDetailAndUpdate('OFFLINE_ORDER_EXPORT', res.taskId);
                  } else {
                    _this.isInQueue = false;
                    _this.$message.info('正在生成导出文件，请稍候...');
                    _this.pollTaskStatus(res.taskId);
                  }
                } else {
                  _this.isExporting = false;
                  _this.$message.error('创建导出任务失败');
                }
              case 1:
                return _context5.a(2);
            }
          }, _callee5);
        }));
        return function (_x2) {
          return _ref.apply(this, arguments);
        };
      }()).catch(function (error) {
        _this.isExporting = false;
        _this.$message.error('导出失败: ' + (error.message || '未知错误'));
      });
    },
    // 轮询任务状态
    pollTaskStatus: function () {
      var _pollTaskStatus = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(taskId) {
        var _this2 = this;
        var pollInterval;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              pollInterval = setInterval(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
                var taskStatus, _t;
                return _regenerator().w(function (_context6) {
                  while (1) switch (_context6.p = _context6.n) {
                    case 0:
                      _context6.p = 0;
                      _context6.n = 1;
                      return orderListApi.getOfflineOrderExportTaskStatus(taskId);
                    case 1:
                      taskStatus = _context6.v;
                      // 更新进度
                      if (taskStatus.status === 'PROCESSING') {
                        _this2.exportProgress = Math.min(_this2.exportProgress + 5, 90);
                      } else if (taskStatus.status === 'COMPLETED') {
                        _this2.exportProgress = 100;
                        clearInterval(pollInterval);

                        // 直接使用filePath中的HTTPS地址下载文件
                        if (taskStatus.filePath) {
                          _this2.downloadFileByFilePath(taskStatus.filePath, taskStatus.fileName);
                        } else if (taskStatus.fileName) {
                          _this2.downloadFile(taskStatus.fileName);
                        }
                        setTimeout(function () {
                          _this2.isExporting = false;
                        }, 1500);
                      } else if (taskStatus.status === 'FAILED') {
                        clearInterval(pollInterval);
                        _this2.isExporting = false;
                        _this2.$message.error('导出失败: ' + (taskStatus.errorMessage || '未知错误'));
                      }
                      _context6.n = 3;
                      break;
                    case 2:
                      _context6.p = 2;
                      _t = _context6.v;
                      clearInterval(pollInterval);
                      _this2.isExporting = false;
                      _this2.$message.error('查询导出状态失败: ' + (_t.message || '未知错误'));
                    case 3:
                      return _context6.a(2);
                  }
                }, _callee6, null, [[0, 2]]);
              })), 2000);
            case 1:
              return _context7.a(2);
          }
        }, _callee7);
      }));
      function pollTaskStatus(_x3) {
        return _pollTaskStatus.apply(this, arguments);
      }
      return pollTaskStatus;
    }(),
    // 获取排队详情并更新位置（显示最大排队位置）
    fetchQueueDetailAndUpdate: function () {
      var _fetchQueueDetailAndUpdate = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(taskType, taskId) {
        var detail, _t2;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.p = _context8.n) {
            case 0:
              _context8.p = 0;
              _context8.n = 1;
              return orderListApi.getDownloadQueueDetail(taskType);
            case 1:
              detail = _context8.v;
              if (detail) {
                this.queueDetail = detail;
                if (detail.userMaxQueuePosition > 0) {
                  this.currentQueuePosition = detail.userMaxQueuePosition;
                }
              }
              this.pollTaskStatusWithQueue(taskId, taskType);
              _context8.n = 3;
              break;
            case 2:
              _context8.p = 2;
              _t2 = _context8.v;
              console.error('获取排队详情失败:', _t2);
              this.pollTaskStatusWithQueue(taskId, taskType);
            case 3:
              return _context8.a(2);
          }
        }, _callee8, this, [[0, 2]]);
      }));
      function fetchQueueDetailAndUpdate(_x4, _x5) {
        return _fetchQueueDetailAndUpdate.apply(this, arguments);
      }
      return fetchQueueDetailAndUpdate;
    }(),
    // 轮询任务状态（支持排队模式）
    pollTaskStatusWithQueue: function () {
      var _pollTaskStatusWithQueue = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0(taskId, taskType) {
        var _this3 = this;
        var pollInterval;
        return _regenerator().w(function (_context0) {
          while (1) switch (_context0.n) {
            case 0:
              pollInterval = setInterval(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9() {
                var detail, taskStatus, _t3, _t4;
                return _regenerator().w(function (_context9) {
                  while (1) switch (_context9.p = _context9.n) {
                    case 0:
                      _context9.p = 0;
                      _context9.p = 1;
                      _context9.n = 2;
                      return orderListApi.getDownloadQueueDetail(taskType);
                    case 2:
                      detail = _context9.v;
                      if (detail) {
                        _this3.queueDetail = detail;
                        if (detail.userMaxQueuePosition > 0) {
                          _this3.currentQueuePosition = detail.userMaxQueuePosition;
                        }
                      }
                      _context9.n = 4;
                      break;
                    case 3:
                      _context9.p = 3;
                      _t3 = _context9.v;
                    case 4:
                      _context9.n = 5;
                      return orderListApi.getOfflineOrderExportTaskStatus(taskId);
                    case 5:
                      taskStatus = _context9.v;
                      if (taskStatus.status === 'WAITING') {
                        _this3.currentQueuePosition = taskStatus.queuePosition || 0;
                      } else if (taskStatus.status === 'PROCESSING') {
                        _this3.isInQueue = false;
                        _this3.exportProgress = 5;
                        clearInterval(pollInterval);
                        _this3.pollTaskStatus(taskId);
                      } else if (taskStatus.status === 'COMPLETED') {
                        _this3.exportProgress = 100;
                        clearInterval(pollInterval);
                        if (taskStatus.filePath) {
                          _this3.downloadFileByFilePath(taskStatus.filePath, taskStatus.fileName);
                        } else if (taskStatus.fileName) {
                          _this3.downloadFile(taskStatus.fileName);
                        }
                        setTimeout(function () {
                          _this3.isExporting = false;
                        }, 1500);
                      } else if (taskStatus.status === 'FAILED') {
                        clearInterval(pollInterval);
                        _this3.isExporting = false;
                        _this3.$message.error('导出失败: ' + (taskStatus.errorMessage || '未知错误'));
                      }
                      _context9.n = 7;
                      break;
                    case 6:
                      _context9.p = 6;
                      _t4 = _context9.v;
                      clearInterval(pollInterval);
                      _this3.isExporting = false;
                      _this3.$message.error('查询导出状态失败: ' + (_t4.message || '未知错误'));
                    case 7:
                      return _context9.a(2);
                  }
                }, _callee9, null, [[1, 3], [0, 6]]);
              })), 2000);
            case 1:
              return _context0.a(2);
          }
        }, _callee0);
      }));
      function pollTaskStatusWithQueue(_x6, _x7) {
        return _pollTaskStatusWithQueue.apply(this, arguments);
      }
      return pollTaskStatusWithQueue;
    }(),
    // 获取导出按钮文本
    getExportButtonText: function getExportButtonText() {
      if (this.isInQueue) {
        return this.currentQueuePosition > 0 ? '排队中 第' + this.currentQueuePosition + '位' : '排队中...';
      }
      return this.isExporting ? '导出中...' : '结果导出';
    },
    // 通过filePath下载文件（支持HTTPS地址）
    downloadFileByFilePath: function downloadFileByFilePath(filePath, fileName) {
      var link = document.createElement('a');
      link.href = filePath;
      link.download = fileName || 'export.xlsx';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      this.$message.success('导出成功');
    },
    // 下载文件
    downloadFile: function downloadFile(fileName) {
      var link = document.createElement('a');
      link.href = fileName;
      link.download = fileName.substring(fileName.lastIndexOf('/') + 1);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      this.$message.success('导出成功');
    }
  }
};